import React from 'react';
import { useLocation } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

import SubNavbar from '../components/SubNavbar';
import ActionButton from '../../ActionButton';
import { getRouteName } from '../../../utils/routesNames';
// import { generateAnalyticsUsersReportRequest } from '../../../sagas/analyticsUsersReport/actions';

import './_performanceNav.scss';

const PerformanceNav = () => {
  // const dispatch = useDispatch();
  const { pathname } = useLocation();
  // const analyticsUsersData = useSelector(s => s.analyticsUsers.listData);

  // const generateCSV = () => {
  //   dispatch(generateAnalyticsUsersReportRequest({ filters: analyticsUsersData.filters, curr_page: analyticsUsersData.curr_page }));
  // };

  return (
    <div className="analyticsUsersNav">
      <SubNavbar route={getRouteName(pathname)}>
        {/*<ActionButton variant="secondary" title="Export CSV" onClick={generateCSV}/>*/}
        <ActionButton disabled variant="secondary" title="Export CSV" onClick={() => console.log('export')}/>
      </SubNavbar>
    </div>
  );
};

export default PerformanceNav;